import React from 'react';
import { FaCheck, FaTimes, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastProps {
  message: string;
  type: ToastType;
  visible: boolean;
  onClose: () => void;
}

const typeConfig: Record<ToastType, { border: string; bg: string; icon: React.ReactNode }> = {
  success: { border: 'border-success', bg: 'bg-success/15', icon: <FaCheck className="text-success" /> },
  error:   { border: 'border-error',   bg: 'bg-error/15',   icon: <FaTimes className="text-error" /> },
  warning: { border: 'border-warning', bg: 'bg-warning/15', icon: <FaExclamationTriangle className="text-warning" /> },
  info:    { border: 'border-info',    bg: 'bg-info/15',    icon: <FaInfoCircle className="text-info" /> },
};

const Toast: React.FC<ToastProps> = ({ message, type, visible, onClose }) => {
  if (!message) return null;
  const s = typeConfig[type];
  return (
    <div className="toast toast-bottom toast-end z-[9999]">
      <div
        className={`flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg backdrop-blur-sm text-base-content
          transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}
          ${s.bg} ${s.border}`}
      >
        <span className="text-base leading-none">{s.icon}</span>
        <span className="text-sm font-medium">{message}</span>
      </div>
    </div>
  );
};

export default Toast;
